<script>


import { useToast } from "vue-toastification";

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import MutationEdit from '@/pages/Core/Mutations/MutationEdit.vue'
import MutationDelete from '@/pages/Core/Mutations/MutationDelete.vue'


import UserCircle from '@/ui/UserCircle'

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getMutations,unlockMutation } from '@/services/serviceMutation';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Mutations',
	mixins: [ MixinGeneralFunct ],
	components: {
		UserCircle
		,MutationEdit,MutationDelete
		,LoadingScreen
		,Alert
	},
	props: ["auth","secData","params"],
	data() {
		return {
			prefix:'',
		
			
			metaData:[],
			
			isLoading:true,
			
			helpboxData: [],
			
			totalCount:0,
			dataList:[],
			selectedFilterText:'',
			
			selectedMutationId:'',
			
						
			showFilter:false,
			filterExtended:false,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',
			
			modalEdit:{},
			modalEditId:'',
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
		
		//na fontende aj preview aj tabula, zober povodne idcka a idcka po aktualizacii a tie naviac zobraz na par sekund inou farbou, alebo ako nove.
		
		//default data
		
		
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true
			
			getMutations({filterText: this.selectedFilterText}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
			
		
		},
		
				
		//odomknutie zaznamu
		onUnLock:function(mutationId){
			this.cSession();
			this.isLoading=true
			unlockMutation({mutationId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box user editacia
		loadModalFormMutationEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedMutationId=recordID;
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box user delete
		loadModalFormMutationDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedMutationId=recordID;
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},
		
		reloadAfterChange() {
			//console.log(e);
			this.onLoadPage();
			this.selectedMutationId='';
			//this.cart.push(e);
			//this.total = this.shoppingCartTotal;
		},

		//vyber stranky v strankovaci
		reloadAfterChangeNrPage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},
		
		//vyber poctu zaznamov
		reloadAfterChangeCountRecords(selectedCount) {
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

		
	},	
	
			
	watch: {
		'auth.mutationsList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
	<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	<div id="version" class="version"><p>{{metaData.version}}</p></div>
				
		<div v-if="metaData.modulAccess"> 
		
			<div class="row">
				<div class="col-12">
				
				
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCore.Mutations') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							
							<button type="button" :disabled="!auth.levelsNew" v-on:click="loadModalFormMutationEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
							
						</div> 
					</div>
																	
							
					<!-- filters basic -->
					<div class="row">
					
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
						
					</div>

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-12">
						</div>
					</div>
					
				</div>
			</div>				
			
			<!-- zakladny zoznam -->
			<div v-if="totalCount>0">
			
				<div class="row">
					<div class="col-12">
	
						<div class="table-responsive">
							<table class="table table-hover table-sm">
							
								<thead>
									<tr>
										<th class="orderBy">id</th>
										
										
										<th>
											{{$t('msgCore.Action')}}
										</th>
										
										<th>{{$t('msgCore.State')}}</th>
										
										
										<th>{{$t('msgCore.Title')}}</th>
										
										<th>{{$t('msgCore.short')}}</th>
										
										
										<th>{{$t('msgCore.Created')}}</th>
										
										<th>{{$t('msgCore.Modified')}}</th>
										
										<th>{{$t('msgCore.AccessLevel')}}/{{$t('msgCore.Users')}}</th>
										
																			
									</tr>
								</thead>
								
								
								<tr v-for="(basicObj ) in dataList" :key="basicObj" >
								
									<td>{{ basicObj.id }}</td>
								
																	
									<td>
										<div class="input-group">	
											
											<button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.mutationsUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
																				
											<div class="btn-group">				
												<button type="button" :disabled="!auth.mutationsEdit" v-on:click="loadModalFormMutationEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="fas fa-edit"></i></button>
										
												<button v-if="basicObj.isAllowedRemove" type="button" :disabled="!auth.mutationsDelete" v-on:click="loadModalFormMutationDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>
															
											</div>	
											
											
											
										</div>	
									</td>
									
									<td :title="basicObj.state_name">
										<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
									</td>	
									
									
									
									<td >{{ basicObj.title }}</td>							
									
									<td >{{ basicObj.shorts }}</td>
									
									
									
									<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
									
								
									<td >{{ basicObj.access_name }}<br>
									
										<span v-for="(user) in basicObj.users" :key="user" >
											<span >{{ user.name }} {{ user.surname }}</span>,
										</span>
									
									</td>
									
									
								</tr>
									

							
							</table>	
						</div>		
					
					</div>
				</div>
					
				<div class="row row-pagination">
					<div class="col-6 col-md-3 col-lg-2">
						
					</div>
					
					<div class="col-6 col-md-3 col-lg-2">
						<div class="form-group form-group-filter">
							<span class="btn btn-default btn-sm">Počet: {{totalCount}}</span>
						</div>
					</div>
					
					<div class="col-12 col-md-6 col-lg-8">	
						
					</div>
				</div>	
				
			</div>	
					
			<div v-else class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>							
			</div>
						
								
		</div>
			
			
		
		<div v-else >
			<div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
			</div>
		</div>
	
		<MutationEdit :auth="auth" :secData="secData" :mutationId="String(selectedMutationId)" @changeRecord="reloadAfterChange" :modalObject="modalEdit" :modalId="modalEditId"></MutationEdit>
		
		<MutationDelete :auth="auth" :secData="secData" :mutationId="String(selectedMutationId)" @changeRecord="reloadAfterChange" :modalObject="modalDelete" :modalId="modalDeleteId"></MutationDelete>
	
	</div>	
</template>


